import { BaseFooter, Footer } from "@product/scmp-sdk";
import { memo } from "react";
import type { FunctionComponent } from "react";

import { Portal } from "~/components/common/portal";
import { useNewsletterWidget } from "~/components/newsletter/newsletter-widget-container/hooks";
import { FooterElementID } from "~/pages/_app/consts";

import { Container } from "./styles";

export type Props = {
  className?: string;
  hasPrintEditionFooter?: boolean;
};

const AppFooter_: FunctionComponent<Props> = ({ className, hasPrintEditionFooter }) => {
  const { dataMatrix } = useNewsletterWidget({
    contentType: "footer",
    eventCategory: "Newsletter (Footer - Inline)",
    section: "",
  });

  const queryParametersForSocialButtons = {};
  return (
    <Portal selector={`#${FooterElementID}`}>
      <Container className={className}>
        {hasPrintEditionFooter ? (
          <Footer
            dataMatrix={dataMatrix}
            queryParametersForSocialButtons={queryParametersForSocialButtons}
          />
        ) : (
          <BaseFooter
            dataMatrix={dataMatrix}
            newsletterItems={[]}
            queryParametersForSocialButtons={queryParametersForSocialButtons}
          />
        )}
      </Container>
    </Portal>
  );
};

export const AppFooter = memo(AppFooter_);

AppFooter.displayName = "AppFooter";
